import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConsentFormComponent } from './consent/consent.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './services/guards/auth-guard';

const routes: Routes = [
  {
    path: 'consent',
    component: ConsentFormComponent,
    canActivate: [AuthGuard],
  },
  { path: '**', component: LoginComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  schemas: [],
})
export class AppRoutingModule {}
